import React from 'react';
import Widget from './widget/index';

const WidgetGrid = ({
    widgets,
    activeClientTab,
    selectedClient,
    widgetContents,
    handleWidgetContentChange,
    deleteWidget,
    selectedUseCase
}) => {
    const filteredWidgets = widgets.filter(widget => widget.tabId === activeClientTab);

    if (filteredWidgets.length === 0) {
        return (
            <div className="text-center py-8">
                <p className="text-gray-500">No widgets in this tab. Add a widget to get started.</p>
            </div>
        );
    }

    return (
        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 p-3 mb-6">
            {filteredWidgets.map(widget => (
                <div key={widget.key || widget.id} className="inline-block w-full mb-6 break-inside-avoid">
                    <Widget
                        id={widget.id}
                        title={widget.title}
                        subtitle={widget.subtitle}
                        prompt={widget.prompt}
                        chartPrompt={widget.chartPrompt ? widget.chartPrompt : null}
                        customerId={selectedClient?.id || widget.customerId}
                        tool={widget.tool}
                        endpoint={widget.endpoint}
                        content={widget.content}
                        status={widget.status}
                        hasAvatar={widget.hasAvatar}
                        onContentChange={handleWidgetContentChange}
                        onDelete={async (id) => {
                            await deleteWidget(id);
                        }}
                        useCaseId={selectedUseCase}
                    />
                </div>
            ))}
        </div>
    );
};

export default WidgetGrid;